export const PARTNER_MAINTENANCE_LEVEL_CODES = [
  'N1',
  'N2',
  'N3',
  'N4',
  'N5',
  'R1',
  'R2',
  'R3',
  'R4',
  'R5',
] as const;

export type PartnerMaintenanceLevelCode =
  (typeof PARTNER_MAINTENANCE_LEVEL_CODES)[number];

export const PARTNER_MAINTENANCE_TIMER_KINDS = [
  'TAKE_CHARGE',
  'INTERVENTION',
  'RESOLUTION',
] as const;

export type PartnerMaintenanceTimerKind =
  (typeof PARTNER_MAINTENANCE_TIMER_KINDS)[number];

export const PARTNER_MAINTENANCE_CLOCK_STARTS = [
  'INCIDENT_DETECTED',
  'FAULT_REPORTED',
  'TICKET_CREATED',
  'TICKET_TAKEN_IN_CHARGE',
  'FIRST_INTERVENTION',
] as const;

export type PartnerMaintenanceClockStart =
  (typeof PARTNER_MAINTENANCE_CLOCK_STARTS)[number];

export const PARTNER_MAINTENANCE_CALENDAR_MODES = [
  'CONTINUOUS_24_7',
  'EXCLUDING_WEEKENDS_AND_HOLIDAYS',
  'BUSINESS_HOURS',
] as const;

export type PartnerMaintenanceCalendarMode =
  (typeof PARTNER_MAINTENANCE_CALENDAR_MODES)[number];

// DEPRECATED (2026-10-08) scope dimensions removed from new saves/publishes: 'DEPARTMENT', 'POSTCODE'. Retain for backward-compat reads only;
export const PARTNER_MAINTENANCE_SCOPE_DIMENSIONS = [
  'MANUFACTURER',
  'MODEL',
  'COMMUNE',
  'ASSET',
] as const;

export type PartnerMaintenanceScopeDimension =
  (typeof PARTNER_MAINTENANCE_SCOPE_DIMENSIONS)[number];

export const PARTNER_MAINTENANCE_INTERVENTION_MODES = [
  'ONSITE',
  'REMOTE',
  'BOTH',
] as const;

export type PartnerMaintenanceInterventionMode =
  (typeof PARTNER_MAINTENANCE_INTERVENTION_MODES)[number];

export const PARTNER_MAINTENANCE_SCOPE_INTERVENTION_MODES = [
  'ONSITE',
  'REMOTE',
] as const;

export type PartnerMaintenanceScopeInterventionMode =
  (typeof PARTNER_MAINTENANCE_SCOPE_INTERVENTION_MODES)[number];

export const PARTNER_MAINTENANCE_SCOPE_EFFECTS = [
  'INCLUDE',
  'EXCLUDE',
] as const;

export type PartnerMaintenanceScopeEffect =
  (typeof PARTNER_MAINTENANCE_SCOPE_EFFECTS)[number];

/** Platform-wide stop for the resolution deadline. Not chosen per contract. */
export const PARTNER_MAINTENANCE_RESOLUTION_STOP =
  'DECLARED_CLOSED_AT' as const;

export const PARTNER_MAINTENANCE_RULES_STATUSES = [
  'DRAFT',
  'PUBLISHED',
] as const;

export type PartnerMaintenanceRulesStatus =
  (typeof PARTNER_MAINTENANCE_RULES_STATUSES)[number];
